import React from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const PaymentModal = ({
  open,
  onClose,
  editedPayment,
  setEditedPayment,
  handlePostPayment,
}) => {
  if (!editedPayment) return null;
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "90%",
      maxWidth: 500,
      bgcolor: "background.paper",
      borderRadius: 2,
      boxShadow: 24,
      maxHeight: "80vh",     
      overflow: "hidden",    
      p: 4,
    }}
      >
     <div style={{ overflowY: "auto", maxHeight: "70vh", padding: 16,   scrollbarWidth: "none", }}>
         <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "grey.700",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" mb={2}>
          Edit Payment
        </Typography>

        <TextField
          label="Plan"
          type="text"
          value={editedPayment?.plan_id || ""}
          onChange={(e) =>
            setEditedPayment({ ...editedPayment, plan_id: e.target.value })
          }
          fullWidth
          margin="normal"
        />
        <TextField
          label="Status"
          value={editedPayment?.payment_status || ""}
          onChange={(e) =>
            setEditedPayment({
              ...editedPayment,
              payment_status: e.target.value,
            })
          }
          fullWidth
          margin="normal"
        />
        <TextField
          label="Amount"
          type="text"
          value={editedPayment?.amount || ""}
          onChange={(e) =>
            setEditedPayment({
              ...editedPayment,
              amount: e.target.value,
            })
          }
          fullWidth
          margin="normal"
        />
        <TextField
          label="Total Alerts"
          type="number"
          value={editedPayment?.total_alerts || ""}
          onChange={(e) =>
            setEditedPayment({
              ...editedPayment,
              total_alerts: e.target.value,
            })
          }
          fullWidth
          margin="normal"
        />
        <TextField
          label="Used Alerts"
          type="number"
          value={editedPayment?.used_alerts ?? ""}
          onChange={(e) =>
            setEditedPayment({
              ...editedPayment,
              used_alerts: e.target.value,
            })
          }
          fullWidth
          margin="normal"
        />
        <TextField
          label="Razorpay Order_id"
          type="text"
          value={editedPayment?.provider_order_id ?? ""}
          onChange={(e) =>
            setEditedPayment({
              ...editedPayment,
              provider_order_id: e.target.value,
            })
          }
          fullWidth
          margin="normal"
        />
        <TextField
          label="payment_id"
          type="text"
          value={editedPayment?.payment_id ?? ""}
          onChange={(e) =>
            setEditedPayment({
              ...editedPayment,
              payment_id: e.target.value,
            })
          }
          fullWidth
          margin="normal"
        />
        <Button
          variant="contained"
          onClick={handlePostPayment}
          fullWidth
          sx={{ mt: 2 }}
        >
          Save Changes
        </Button>
     </div>
      </Box>
    </Modal>
  );
};

export default PaymentModal;
